import React from "react";
import {Form, Input} from "antd";
import FilterContainer, {CoreFiltersBaseProps} from "../../../../../../components/FilterContainer";

export default function SystemAssetsScreenFilters({filter, onSubmit}: CoreFiltersBaseProps) {
  return (
    <FilterContainer
      onResetFilters={filter.resetFilters}
      onSubmit={onSubmit}
      isSubmitting={undefined}
    >
      <Form layout='vertical'>
        <Form.Item label='Name'>
          <Input
            allowClear
            value={filter.getFilter('name')}
            onChange={e => filter.setFilter('name', e.target.value)}
          />
        </Form.Item>
      </Form>
    </FilterContainer>
  )
}
